<template>
  <lazy-component>
    <div class="wrapper">
      <iframe
        width="500"
        height="479"
        :src="src"
        frameborder="0"
        style="border:none;overflow:hidden"
        scrolling="no"
        allowTransparency="true"
        allow="encrypted-media"
        allowfullscreen
      ></iframe>
    </div>
  </lazy-component>
</template>

<script>
export default {
  name: "app-facebook",
  props: {
    url: {
      type: String,
      required: true
    },
    type: {}
  },
  computed: {
    src() {
      return `https://www.facebook.com/plugins/post.php?href=${this.url}&width=500`;
    }
  }
};
</script>

<style scoped lang="scss">
.wrapper {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
</style>
